import classnames from 'classnames/bind'
import React from 'react'

import BulletStep, { BulletStepProps } from '~/components/BulletStep'
import RichText, { RichTextBlock } from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface EditoBulletStepsProps {
  className?: string
  title?: RichTextBlock[]
  items?: BulletStepProps[]
}

function EditoBulletSteps({ className, title, items }: EditoBulletStepsProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })
  const titleStyle = useStyle({
    textPreset: 'title-section-page',
  })

  return (
    <div className={cx(css.EditoBulletSteps, className)}>
      <div className={cx(css.grid, gridStyle)}>
        <div className={css.content}>
          {title && (
            <RichText className={cx(css.title, titleStyle)} render={title} />
          )}
          <div className={css.bullets}>
            {items?.map((item, index) => {
              return (
                <BulletStep
                  key={index}
                  className={css.bulletItem}
                  index={index}
                  {...item}
                />
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

EditoBulletSteps.defaultProps = {}

export default EditoBulletSteps
